import { useMemo } from "react";

import { useGetPages } from "../../../api/insights";
import { RankedBarChart } from "../charts";
import SectionShell, {
  Stat,
  StatGrid,
  formatNum,
  formatPct,
} from "../SectionShell";
import { useChartTimeFrame } from "../useChartTimeFrame";
import { toRangeParams } from "../timeFrame";

function PagesUsage({ eventId }) {
  const tf = useChartTimeFrame(eventId);
  const { data, isPending, isError, error } = useGetPages(
    eventId,
    toRangeParams(tf.range)
  );

  const chart = useMemo(
    () =>
      (data?.viewsPerPage ?? []).map((r) => ({
        page: `${r.name ?? "(unknown)"}${r.isLink ? " (link)" : ""}`,
        Views: r.viewCount,
        "Unique users": r.uniqueUsers,
      })),
    [data]
  );

  return (
    <SectionShell
      id="pagesUsage"
      title="Pages usage"
      description="How many app users opened informational pages."
      isPending={isPending}
      isError={isError}
      error={error}
      eventId={eventId}
      analysisKey="pagesUsage"
      headerRight={tf.control}
    >
      <StatGrid>
        <Stat
          part="activeAppUsers"
          label="Active app users"
          value={formatNum(data?.totalAppUsers)}
        />
        <Stat
          part="openedPageRate"
          label="Opened ≥1 page"
          value={formatPct(data?.atLeastOnePageRate)}
        />
        <Stat
          part="pagesTracked"
          label="Pages tracked"
          value={formatNum(chart.length)}
        />
      </StatGrid>

      <RankedBarChart
        part="viewsPerPage"
        title="Views per page"
        data={chart}
        categoryKey="page"
        series={[
          { name: "Unique users", color: "teal.6", stackId: "totals" },
          { name: "Views", color: "blue.6", stackId: "totals" },
        ]}
      />
    </SectionShell>
  );
}

export default PagesUsage;
